import React from 'react';
import styled from 'styled-components';
import { i18n } from '@international/mastodon-i18n';

const GoogleIcon = () => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path
      d='M15.83 8.18C15.83 7.653 15.783 7.153 15.703 6.667H8.17v3.006h4.313c-.193.987-.76 1.82-1.6 2.387v2h2.574c1.506-1.393 2.373-3.447 2.373-5.88Z'
      fill='#4285F4'
    />
    <path
      d='M8.17 16c2.16 0 3.967-.72 5.287-1.94l-2.574-2c-.72.48-1.633.773-2.713.773-2.087 0-3.853-1.406-4.487-3.306H1.03v2.06A7.998 7.998 0 0 0 8.17 16Z'
      fill='#34A853'
    />
    <path
      d='M3.683 9.527A4.794 4.794 0 0 1 3.43 8c0-.533.093-1.047.253-1.527V4.413H1.03A7.965 7.965 0 0 0 .17 8c0 1.293.313 2.507.86 3.587l2.653-2.06Z'
      fill='#FBBC05'
    />
    <path
      d='M8.17 3.167c1.18 0 2.233.406 3.067 1.2l2.28-2.28C12.137.793 10.33 0 8.17 0 5.043 0 2.343 1.8 1.03 4.413l2.653 2.06c.634-1.9 2.4-3.306 4.487-3.306Z'
      fill='#EA4335'
    />
  </svg>
);

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  height: 40px;
  padding: 0 32px;
  background-color: #fff !important;
  color: var(--cds-text-primary, #1b2127) !important;
  border: 1px solid #e1e6eb !important;
  border-radius: 4px !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover:not(:disabled) {
    background-color: #f5f7f9 !important;
  }

  &:focus-visible {
    outline: 2px solid var(--cds-focus, #0f62fe);
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

interface WorkOSGoogleButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const WorkOSGoogleButton: React.FC<WorkOSGoogleButtonProps> = ({
  onClick,
  disabled,
}) => {
  return (
    <StyledButton
      type='button'
      data-testid='workos-google-button'
      onClick={onClick}
      disabled={disabled}
    >
      <GoogleIcon />
      {i18n.getStr('components.WorkOSLogin.continueWithGoogle')}
    </StyledButton>
  );
};

export default i18n.renderTranslation()(WorkOSGoogleButton);
